export default __webpack_public_path__ + "static/media/graphic-progression_green.8103f70b.svg";